module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"send_button.label":"Enviar"},"en":{"send_button.label":"Send"}}')
  delete Component.options._Ctor
}
